import React from 'react'
import './section.scss'
import { LoaderWrapper } from 'uiComponents/loaders'

interface SectionProps {
    title?: string | React.ReactNode
    children: React.ReactNode
    className?: string
    isLoading?: boolean
}

const Section = ({ title, children, className, isLoading }: SectionProps) => (
    <div className={`membership-details-section ${className}`}>
        <div className="section-header">
            {typeof title === 'string' ? <h5 className="section-title">{title}</h5> : title}
        </div>
        <div className="section-content">
            <LoaderWrapper loading={isLoading}>{children}</LoaderWrapper>
        </div>
    </div>
)

export default Section
